<template>
  <div class="main">
    <Head type="pilu" />

    <div class="pilu">
      <div class="left" id="item">
        <div class="title">信息披露</div>
        <div
          class="item"
          v-bind:class="{ check: companyInfo }"
          v-on:click="category('companyInfo')"
        >
          公司资质
        </div>
        <div
          class="item"
          v-bind:class="{ check: registeredTrademark }"
          v-on:click="category('registeredTrademark')"
        >
          分支机构
        </div>
        <div
          class="item"
          v-bind:class="{ check: internetProductInfo }"
          v-on:click="category('internetProductInfo')"
        >
          互联网平台及产品信息
        </div>
        <div
          class="item"
          v-bind:class="{ check: queryAndChecked }"
          v-on:click="category('queryAndChecked')"
        >
          重大事项变更
        </div>
        <div
          class="item"
          v-bind:class="{ check: insuranceCompanyCooperation }"
          v-on:click="category('insuranceCompanyCooperation')"
        >
          保险公司合作信息
        </div>
        <div
          class="item"
          v-bind:class="{ check: customerServiceAndConsumer }"
          v-on:click="category('customerServiceAndConsumer')"
        >
          客户服务及消费者投诉方式
        </div>
        <a
          href="http://icid.iachina.cn/?columnid_url=201509301401"
          target="_blank"
        >
          <img :src="$config.IMG_URL + '/baoxianxiehui.png'" />
        </a>
      </div>

      <CompanyInfo v-if="companyInfo" />
      <RegisteredTrademark v-if="registeredTrademark" />
      <InternetProductInfo v-if="internetProductInfo" />
      <QueryAndChecked v-if="queryAndChecked" />
      <InsuranceCompanyCooperation v-if="insuranceCompanyCooperation" />
      <CustomerServiceAndConsumer v-if="customerServiceAndConsumer" />
    </div>

    <Footer />
  </div>
</template>

<script>
import Head from "./../components/head";
import Footer from "./../components/footer";
import CompanyInfo from "./companyInfo";
import RegisteredTrademark from "./registeredTrademark";
import InternetProductInfo from "./internetProductInfo";
import QueryAndChecked from "./queryAndChecked";
import InsuranceCompanyCooperation from "./insuranceCompanyCooperation";
import CustomerServiceAndConsumer from "./customerServiceAndConsumer";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "Pilu",
  //props:['sectionCode'],
  data: {
    companyInfo: true,
    registeredTrademark: false,
    internetProductInfo: false,
    queryAndChecked: false,
    insuranceCompanyCooperation: false,
    customerServiceAndConsumer: false,
  },

  components: {
    Head,
    Footer,
    CompanyInfo,
    RegisteredTrademark,
    InternetProductInfo,
    QueryAndChecked,
    InsuranceCompanyCooperation,
    CustomerServiceAndConsumer,
  },
  data() {
    return {
      companyInfo: true,
      registeredTrademark: false,
      internetProductInfo: false,
      queryAndChecked: false,
      insuranceCompanyCooperation: false,
      customerServiceAndConsumer: false,
    };
  },
  methods: {
    category: function (catInfo) {
      this.companyInfo = catInfo == 'companyInfo';
      this.registeredTrademark = catInfo == 'registeredTrademark';
      this.internetProductInfo = catInfo == 'internetProductInfo';
      this.queryAndChecked = catInfo == 'queryAndChecked';
      this.insuranceCompanyCooperation = catInfo == 'insuranceCompanyCooperation';
      this.customerServiceAndConsumer = catInfo == 'customerServiceAndConsumer';
    },
  },
  mounted() {
    document.getElementById("app").scrollTop = 0;
  },
};
</script>

<style scoped lang="less">
@import "./../assets/common";
.main {
  position: relative;
  width: 100%;
  min-width: 1364px;
  /*min-width: 800px;*/
  padding-top: 132px;
  max-width: 1920px;
  /*max-width: 1000px;*/
  margin: 0 auto;
  overflow: hidden;
}

.banner {
  width: 100%;
  height: 816px;
  .swiper-slide {
    position: relative;
    overflow: hidden;
    img {
      height: 816px;
      position: relative;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}

.pilu {
  width: 100%;

  width: 1200px;
  //min-width: 1364px;
  position: relative;
  overflow: hidden;
  margin: 10px auto;
  align-content: center;
  display: flex;
  .left {
    width: 170px;
    margin-right: 35px;
    .title {
      width: 100%;
      height: 44px;
      line-height: 44px;
      background-image: -webkit-linear-gradient(315deg, #ff430b, #f68f27);
      background-image: -o-linear-gradient(315deg, #ff430b, #f68f27);
      background-image: linear-gradient(135deg, #ff430b, #f68f27);
      color: #fff;
      cursor: pointer;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      font-size: 16px;
    }
    .item {
      width: calc(100% - 2px);
      line-height: 20px;
      cursor: pointer;
      border-left: 1px solid #f1f1f1;
      border-right: 1px solid #f1f1f1;
      border-bottom: 1px solid #f1f1f1;
      -webkit-transition: all 0.2s;
      -o-transition: all 0.2s;
      transition: all 0.2s;
      padding: 20px 5px;
    }
    .check {
      color: #f06451;
    }
  }

  .title {
    width: 100%;
    text-align: center;
    font-size: 36px;
    height: 60px;
    line-height: 60px;
  }
}

.follow {
  width: 100%;
  height: 320px;
  min-width: 1364px;
  position: relative;
  overflow: hidden;
  background: #fbfbfb;
  .qr {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 120px;
    width: 454px;
    img {
      width: 120px;
      height: 120px;
    }
    p {
      font-size: 20px;
      line-height: 30px;
      &.tit {
        font-size: 36px;
        font-weight: bold;
        line-height: 60px;
      }
      &.small {
        font-size: 18px;
      }
    }
  }
}

.content {
  overflow: hidden;
}
</style>

<style lang="less">
@import "./../assets/common";

.banner_page {
  bottom: 20px !important;
  .swiper-pagination-bullet {
    background: #e0d5d5;
    opacity: 1;
    margin: 0 8px !important;
  }
  .swiper-pagination-bullet-active {
    background: @blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pilu.vue